import api from '@/utils/api';

/**
 * Bulk Update Dealer pricing
 * @param {string} id Dealer id
 * @param {object} importData - The import price data
 * @returns {Promise}
 */
const bulkUpdateDealerPriceList = (id, importData) =>
  api.patch(`/dealer/${id}/price/bulk-update`, importData);

export default bulkUpdateDealerPriceList;
